// cn.js
module.exports = {
  router_title_001: "首頁",
  router_title_002: "郵件",
  router_title_003: "寫信",
  router_title_004: "發送完成",
  router_title_005: "新頁讀信",
  router_title_006: "超大附件",
  router_title_007: "帳號資訊",
  router_title_008: "帳號安全",
  router_title_009: "异地登入日誌",
  router_title_010: "信任登入地點",
  router_title_011: "修改密碼",
  router_title_012: "其他郵箱帳戶（POP）",
  router_title_013: "添加其他郵箱帳戶",
  router_title_014: "資料夾管理",
  router_title_015: "黑名單",
  router_title_016: "自動轉發與回復",
  router_title_017: "自動轉發設定日誌",
  router_title_018: "郵件分類規則",
  router_title_019: "新建規則",
  router_title_020: "設定日誌",
  router_title_021: "常規設定",
  router_title_022: "用戶端設定",
  router_title_023: "個性簽名",
  router_title_024: "新建簽名",
  router_title_025: "反垃圾設定",
  router_title_026: "通訊錄",
  router_title_027: "綁定手機",
  router_title_028: "解綁手機",
  wm_lang_9c710b:"文件大小為",
  wm_lang_html_95b351:"編輯",
  wm_lang_html_e0f673:"該功能已被禁用，請聯系管理員",
  wm_lang_f90387:"多個關鍵字之間請以英文逗號分隔",
  wm_lang_html_f3a485:"新建文件夾",
  wm_lang_html_0b543c:"管理員已禁用自動轉發到外域",
  wm_lang_html_9c51b4:"續期",
  wm_lang_669656:"規則名字不少於",
  wm_lang_html_e8e492:"新增分類自動轉發功能，支持按照過濾條件設定自動轉發；",
  wm_lang_fec2b4:"客戶端授權碼",
  wm_lang_html_24c669:"郵件總數（封）",
  wm_lang_html_3d448d:"三級導航",
  wm_lang_html_0d8f65:"紅色簡約",
  wm_lang_html_6b0d50:"手機：",
  wm_lang_e680e9:"計算完成",
  wm_lang_58c224:"最多不超過",
  wm_lang_e2ee4e:"每兩天",
  wm_lang_53d9ef:"編碼選擇",
  wm_lang_dbf6d0:"請輸入郵箱",
  wm_lang_76ea0d:"密送人",
  wm_lang_html_fb5bf1:"收件人",
  wm_lang_html_eab129:"個人信息",
  wm_lang_b09b04:"電話最多添加",
  wm_lang_html_4de530:"語言及時區",
  wm_lang_cc97eb:"目的文件夾隸屬於源文件夾",
  wm_lang_html_7a3680:"郵件開發部",
  wm_lang_5d44d9:"存在同名文件夾",
  wm_lang_e747e8:"秒再次獲取",
  wm_lang_b720a6:"审核中",
  wm_lang_953b40:"不包含附件",
  wm_lang_html_9439fa:"開啟客戶端授權碼後，原郵箱密碼將不能登入客戶端，只能使用新增的授權碼登入。",
  wm_lang_html_2df6a3:"發件人：",
  wm_lang_2f234b:"草稿保存成功",
  wm_lang_html_38cf16:"確定",
  wm_lang_425169:"郵件內容",
  wm_lang_html_d43e13:"組織通訊錄",
  wm_lang_html_043897:"郵件短信提醒",
  wm_lang_199536:"郵箱密碼不能為空",
  wm_lang_ef0b42:"模块擴容",
  wm_lang_html_d3298c:"個人通訊錄",
  wm_lang_html_f10ed4:"新建規則",
  wm_lang_html_a34e49:"此文件夾下沒有任何郵件。",
  wm_lang_html_5ee6c3:"拖拽添加",
  wm_lang_html_55405e:"導出",
  wm_lang_c566ca:"服務器",
  wm_lang_html_5abe91:"未星標",
  wm_lang_d87502:"個字符以上主持人郵箱填寫",
  wm_lang_b7612b:"空",
  wm_lang_html_fd5757:"新增釣魚連結提醒，當點擊郵件正文連結時彈出安全提示；",
  wm_lang_19cd24:"雲視",
  wm_lang_0c686f:"輸入長度不超過",
  wm_lang_html_973732:"已轉發",
  wm_lang_331b7f:"不包括",
  wm_lang_ff1c7d:"查看信頭",
  wm_lang_6a3db1:"封郵件",
  wm_lang_c9a507:"更新提示",
  wm_lang_58f966:"大小",
  wm_lang_html_5b0520:"應用",
  wm_lang_1e6021:"新頁簽打開",
  wm_lang_4848e1:"垃圾郵件提醒設定",
  wm_lang_7a615e:"員工編號",
  wm_lang_e8ed1b:"編輯其他郵箱帳號",
  wm_lang_b33403:"每次只能導入",
  wm_lang_8c3f97:"下午好！",
  wm_lang_html_1dea3a:"且",
  wm_lang_379b24:"不超過",
  wm_lang_9aab18:"編輯組",
  wm_lang_html_e5f71f:"搜索",
  wm_lang_abeee9:"反垃圾級別",
  wm_lang_f12e4a:"如果",
  wm_lang_html_da671a:"微信：",
  wm_lang_html_cb0ed5:"緊急",
  wm_lang_188e4b:"移動到指定文件夾",
  wm_lang_320dcb:"密碼强度",
  wm_lang_html_88f1fc:"此發件人",
  wm_lang_d716f1:"到",
  wm_lang_html_5b6010:"和一些其他應用程序的",
  wm_lang_93d159:"已發送",
  wm_lang_html_f1d5f5:"列表佈局",
  wm_lang_a11cc7:"請輸入內容",
  wm_lang_html_5120e6:"有超過",
  wm_lang_html_c247ad:"未讀郵件",
  wm_lang_00237d:"密送人：",
  wm_lang_20a495:"複製成功",
  wm_lang_html_a7a6eb:"的郵件",
  wm_lang_d1a00e:"附件名稱",
  wm_lang_html_58037b:"：",
  wm_lang_c14d45:"設定頁面包屑導航",
  wm_lang_html_4d7ea6:"保存草稿",
  wm_lang_8ea35c:"修改簽名",
  wm_lang_2299ac:"請輸入正確的傳真",
  wm_lang_cae255:"上傳時間",
  wm_lang_84bef0:"修改規則",
  wm_lang_517f89:"傳真重複",
  wm_lang_html_189c20:"未選中任何連絡人，按一下一條連絡人信息在此",
  wm_lang_html_7cf1f5:"每頁顯示",
  wm_lang_html_ee8ecb:"優先級",
  wm_lang_e366cc:"設定",
  wm_lang_html_c3ba16:"已歸檔",
  wm_lang_465afe:"人",
  wm_lang_html_0ec9ea:"更多",
  wm_lang_29d09a:"上海市普陀區金沙江路",
  wm_lang_2c825a:"選擇時間",
  wm_lang_html_5ef69f:"圖標",
  wm_lang_1ca99a:"產品公告",
  wm_lang_html_8becc4:"反垃圾設定",
  wm_lang_abb501:"金色時光",
  wm_lang_html_a71852:"或",
  wm_lang_html_a2247c:"打包下載",
  wm_lang_a2b5f6:"操作者郵箱",
  wm_lang_8b6aed:"線上預覽",
  wm_lang_4c50ee:"頭像",
  wm_lang_a53c6f:"您要删除掉這條規則嗎？",
  wm_lang_html_0dee1e:"审核結果：",
  wm_lang_html_d9cc43:"超大附件空間信息",
  wm_lang_96d2b7:"永久删除",
  wm_lang_html_cecc29:"寫信",
  wm_lang_f4578a:"密碼修改成功，請重新登入。",
  wm_lang_dc9dae:"非法地址或域，請重新輸入！",
  wm_lang_829abe:"分組",
  wm_lang_2b45e2:"是否繼續",
  wm_lang_6f4450:"每日分享",
  wm_lang_873178:"點擊關閉標籤",
  wm_lang_e5a33f:"郵件最大值最小值填寫不正確（最小值要小於等於最大值）",
  wm_lang_78f395:"下拉",
  wm_lang_html_411fee:"網頁製作工程師",
  wm_lang_1ec4aa:"小於等於",
  wm_lang_html_db1c89:"首頁",
  wm_lang_2e28bb:"收信時姓名顯示",
  wm_lang_html_ba7cb4:"代办郵件",
  wm_lang_a820f8:"已設為已讀",
  wm_lang_e39ffe:"請輸入密碼",
  wm_lang_html_1d4403:"超大附件自上傳之日起自動保存",
  wm_lang_html_1535fc:"發送",
  wm_lang_df23a5:"主題：",
  wm_lang_html_a06d40:"開通",
  wm_lang_930882:"個",
  wm_lang_html_db06c7:"測試",
  wm_lang_html_b2352a:"保存到已發送",
  wm_lang_2ad202:"僅對通訊錄中的連絡人發送自動回復",
  wm_lang_html_3be934:"已讀郵件",
  wm_lang_fe30da:"轉發地址已經存在！",
  wm_lang_html_ff05d1:"郵件從小到大",
  wm_lang_html_e77c07:"帳號安全等級：",
  wm_lang_html_1b1d05:"發送至",
  wm_lang_3a580c:"回復全部",
  wm_lang_html_055692:"添加連絡人",
  wm_lang_1e1459:"部門",
  wm_lang_3c3479:"選項一",
  wm_lang_html_ec8d26:"郵箱容量",
  wm_lang_14b860:"至少選擇一項執行動作",
  wm_lang_html_21e106:"轉發",
  wm_lang_html_543b04:"已選中",
  wm_lang_html_7fc88a:"修改密碼",
  wm_lang_html_a86903:"更多信息",
  wm_lang_b0b69e:"請輸入正確的傳真號碼",
  wm_lang_html_fcec0a:"公司網址：",
  wm_lang_9970ad:"主題",
  wm_lang_html_2f78b7:"作為附件轉發",
  wm_lang_1bb474:"新密碼不能與原密碼相同",
  wm_lang_fd2bf0:"僅在以下時間段生效",
  wm_lang_3d3057:"自動收信",
  wm_lang_9bd442:"雲課堂",
  wm_lang_d1d904:"執行動作",
  wm_lang_cf10dc:"位",
  wm_lang_63e0ca:"需要回執",
  wm_lang_23b8db:"When the message arrives",
  wm_lang_a67a18:"個郵件簽名",
  wm_lang_60d045:"姓名",
  wm_lang_cb0804:"默認密送地址",
  wm_lang_0d5523:"每六天",
  wm_lang_html_c39922:"退出",
  wm_lang_html_3b47d7:"文件，且不超過",
  wm_lang_5ea696:"回復時加入原信",
  wm_lang_1501d5:"郵件主題",
  wm_lang_6ed179:"規則名字不能為空",
  wm_lang_html_11ccee:"等",
  wm_lang_html_47595b:"版",
  wm_lang_fb5158:"請輸入正確的合法郵箱",
  wm_lang_72d55e:"輸入新密碼",
  wm_lang_html_fa8b0f:"审核時限：",
  wm_lang_html_ac1e1c:"收件人：",
  wm_lang_19eb5b:"原始文件字段名稱",
  wm_lang_43ef05:"介於",
  wm_lang_html_5aefca:"佈局",
  wm_lang_31fd4b:"垃圾郵件删除時間",
  wm_lang_b15d91:"關閉",
  wm_lang_710ad0:"禁用",
  wm_lang_80c18f:"搜索電子郵件",
  wm_lang_812d1b:"保存客戶端發信",
  wm_lang_cb6d41:"您不會收到來自黑名單地址的郵件。",
  wm_lang_9c19a4:"請輸入原密碼",
  wm_lang_html_413db9:"條匹配，請輸入更多信息以縮小範圍",
  wm_lang_html_bbdfe1:"陳旭",
  wm_lang_html_ecac25:"主題降序",
  wm_lang_622b43:"家庭",
  wm_lang_c33c30:"商務辦公",
  wm_lang_ad9c40:"請填寫內容",
  wm_lang_092ba7:"高級搜索",
  wm_lang_html_eb3c99:"京",
  wm_lang_a0db8e:"“郵件”、“電話”、“傳真”之外的其他字段只能有唯一對應",
  wm_lang_html_5d36f1:"工作信息",
  wm_lang_html_01cd93:"删除已自動轉發的郵件",
  wm_lang_3a17b7:"分鐘",
  wm_lang_fd2515:"自動回復勾選後回復內容不能為空",
  wm_lang_d47c7f:"弄",
  wm_lang_183abe:"通訊錄",
  wm_lang_80ef9d:"上傳頭像圖片大小不能超過",
  wm_lang_html_6785d8:"完成代办",
  wm_lang_html_8d9a07:"導入",
  wm_lang_f41cf0:"請輸入正確郵箱或功能變數名稱",
  wm_lang_3b1083:"保存成功",
  wm_lang_html_6afaf4:"執行以下操作",
  wm_lang_4ebcc8:"域公告郵件",
  wm_lang_9fd1b7:"單選",
  wm_lang_c054fb:"更新記錄",
  wm_lang_cd649f:"時間範圍",
  wm_lang_ca2153:"勾選了自動轉發，則自動轉發內容不能為空",
  wm_lang_3b239d:"無主題",
  wm_lang_4249f2:"選項三",
  wm_lang_f13597:"選擇對應字段名稱",
  wm_lang_d3637f:"發信",
  wm_lang_html_c57120:"題",
  wm_lang_html_bb4546:"立即優化",
  wm_lang_87ba17:"小時到期",
  wm_lang_html_b8ef0f:"已勾選",
  wm_lang_html_46042d:"超大附件",
  wm_lang_html_5f10ee:"經典木紋",
  wm_lang_html_0807a3:"青青幽境",
  wm_lang_3cebfa:"上午好！",
  wm_lang_html_2d66a1:"只能上傳",
  wm_lang_html_456b82:"生日：",
  wm_lang_69be67:"修改成功",
  wm_lang_bff744:"舉報",
  wm_lang_062ebd:"讀信詳情頁",
  wm_lang_c9ef57:"如果您休假時無法回復郵件，可以設定自動回復告知對方。",
  wm_lang_html_df23a5:"主題：",
  wm_lang_b2f801:"您確定要關閉",
  wm_lang_1efeae:"緩慢",
  wm_lang_html_812024:"审核郵件",
  wm_lang_1b3bf0:"寫信預設字體",
  wm_lang_922a77:"自動回復",
  wm_lang_7a311d:"回復：【陞級公告】暢聽支持",
  wm_lang_html_bffb1c:"個性簽名",
  wm_lang_185839:"視窗佈局",
  wm_lang_9b3884:"請填寫最大值",
  wm_lang_html_773926:"不少於",
  wm_lang_html_939d53:"提交",
  wm_lang_html_96d2b7:"永久删除",
  wm_lang_html_de8610:"二級標題",
  wm_lang_html_8c18cb:"此郵件已被审核完成：由於此郵件在审核時限內，审核人並沒有做出裁决，此郵件已被正常投遞",
  wm_lang_html_ef801d:"收信",
  wm_lang_66c3e5:"綠意風情",
  comm_lang_0001:"天的郵件",
  wm_lang_html_738bc9:"您確定要删除所選的連絡人？",
  wm_lang_html_607e7a:"查看",
  wm_lang_7d41a2:"總分块：",
  wm_lang_2005d7:"為了您的帳號安全，請修改密碼",
  wm_lang_html_615db5:"張三",
  wm_lang_faaadc:"序號",
  wm_lang_318305:"新寫信頁打開，您之前所編輯的內容已經保存草稿",
  wm_lang_html_3be506:"收取設定",
  wm_lang_html_38294f:"顯示及換膚",
  wm_lang_html_76b8e6:"格式有誤，正確格式如：1980-09-01。",
  comm_lang_0006:"查找到",
  comm_lang_0007:"發件人包含",
  comm_lang_0008:"收件人包含",
  comm_lang_0009:"主題包含",
  comm_lang_0002:"共",
  comm_lang_0003:"封",
  comm_lang_0004:"郵件",
  comm_lang_0005:"搜索結果",
  wm_lang_9f22bc:"選字體",
  wm_lang_html_c7bc5c:"添加密送",
  comm_lang_0010:"附件名包含",
  wm_lang_d32b45:"請填寫簽名內容",
  wm_lang_html_2f4aad:"删除",
  comm_lang_0011:"時間從",
  wm_lang_9e4d59:"郵箱密碼",
  comm_lang_0012:"到",
  wm_lang_html_8e16eb:"郵件分類規則",
  wm_lang_html_afcb3b:"家庭地址：",
  wm_lang_cb0ed5:"緊急",
  wm_lang_html_2d7a2f:"確",
  wm_lang_15d410:"個字符",
  wm_lang_html_c45357:"系統提示",
  wm_lang_457406:"取消上傳",
  wm_lang_2de0d4:"小時",
  wm_lang_5e579b:"請輸入正確數值",
  wm_lang_html_882106:"分類規則設定日誌",
  wm_lang_92448a:"手機號碼",
  wm_lang_html_9989a0:"標記為",
  wm_lang_html_e41447:"打印",
  wm_lang_html_9ef98a:"對不起，該文件暫不支持預覽",
  comm_lang_0017:"沒有已星標的郵件，您可以為重要郵件加注星標，使郵件查找更為方便。",
  comm_lang_0018:"沒有找到",
  comm_lang_0019:"的郵件",
  wm_lang_625fb2:"取消",
  comm_lang_0013:"的",
  comm_lang_0014:"頁",
  wm_lang_be6f79:"默認簽名",
  comm_lang_0015:"沒有任何郵件",
  comm_lang_0016:"此文件夾下沒有任何郵件。",
  comm_lang_0020:"沒有任何郵件符合您的搜索條件，請您重新設定搜索規則。",
  wm_lang_06e84a:"繼續上傳",
  wm_lang_2b6bc0:"操作",
  comm_lang_0021:"其中",
  comm_lang_0022:"未讀郵件",
  comm_lang_0023:"全部置為已讀",
  wm_lang_22b433:"草稿",
  wm_lang_html_f26ef9:"下載",
  wm_lang_ea8b1d:"無法創建",
  wm_lang_6fc450:"不顯示垃圾郵件中的圖片，手動點擊後顯示",
  wm_lang_c4c3f3:"原郵箱中保留副本",
  wm_lang_d7ec2d:"名稱",
  wm_lang_html_b15d91:"關閉",
  wm_lang_d28df0:"姓名、拼音、首字母搜索連絡人",
  wm_lang_7f72e8:"線上客服",
  wm_lang_35242c:"普通",
  comm_lang_0028:"1.僅支持撤回發往本郵件系統內的郵件，不支持撤回發往其它郵件系統的郵件",
  wm_lang_1f4c10:"資料夾",
  comm_lang_0029:"2.僅支持撤回網頁郵箱中的郵件，不支持撤回被郵件客戶端收取到本地的郵件",
  wm_lang_3ffa1d:"包括",
  comm_lang_0024:"立即删除所有垃圾郵件",
  comm_lang_0025:"郵件加密",
  wm_lang_e9e805:"郵件",
  comm_lang_0026:"撤回郵件",
  wm_lang_html_f952f5:"同步至雲日程",
  comm_lang_0027:"您確定要撤回郵件嗎？如果撤回成功，對方將只能看到郵件的主題，並得到已被撤回的提示。",
  comm_lang_0031:"4.只能撤回7日內發送的郵件",
  wm_lang_html_7d0177:"提示：當對方發來的郵件標題包含",
  comm_lang_0032:"撤回失敗，郵件超過天或已被收件人删除",
  comm_lang_0033:"正在撤回",
  wm_lang_bc4364:"無限制",
  comm_lang_0034:"完成撤回",
  comm_lang_0030:"3.撤回結果將通過系統郵件通知您",
  wm_lang_9c3c31:"要添加到的組不能為空",
  wm_lang_3b3190:"附加意見",
  wm_lang_60eec8:"運維",
  wm_lang_b652de:"職位",
  wm_lang_e11f7c:"左邊的值要小於右邊",
  comm_lang_0039:"郵件撤回失敗",
  wm_lang_2432b5:"備註",
  wm_lang_b58c75:"添加",
  comm_lang_0035:"撤回失敗",
  comm_lang_0036:"成功撤回",
  comm_lang_0037:"對方非本郵件系統郵箱，無法撤回",
  comm_lang_0038:"撤回失敗，郵件可能已被删除",
  wm_lang_86ed3d:"移動到",
  comm_lang_0042:"部分撤回",
  comm_lang_0043:"發信方已撤回郵件",
  wm_lang_d6cc4b:"第四步，開始上傳",
  comm_lang_0044:"此郵件已被發件人撤回",
  comm_lang_0045:"發信時間",
  wm_lang_html_ac8ccc:"左右佈局",
  wm_lang_html_74c0d8:"提醒語言",
  wm_lang_html_0611d8:"）",
  wm_lang_2456c8:"請完善信息",
  comm_lang_0040:"撤回狀態",
  wm_lang_7a2e8b:"這不是垃圾郵件",
  comm_lang_0041:"已全部撤回",
  wm_lang_cef67a:"日文",
  wm_lang_html_317a66:"中包含",
  wm_lang_a81052:"密碼",
  wm_lang_33130f:"操作成功",
  wm_lang_8347a9:"修改",
  wm_lang_html_6bac4d:"導入連絡人",
  wm_lang_437839:"郵件主題長度限制為",
  wm_lang_html_be5fbb:"保存",
  wm_lang_43b510:"剩餘",
  wm_lang_4076f9:"寫信頁",
  wm_lang_html_fb8f3d:"請選擇新文件存放的位置：",
  wm_lang_cda4d5:"從連絡人中選擇",
  wm_lang_38e3ff:"收到的共亯",
  wm_lang_f15261:"片段",
  wm_lang_e13556:"包含",
  wm_lang_69e308:"含附件",
  wm_lang_732796:"徹底删除",
  wm_lang_html_ba8713:"信任",
  wm_lang_ec84ea:"公司網址",
  comm_lang_0046:"年",
  wm_lang_8e97c5:"發信時間",
  comm_lang_0047:"月",
  wm_lang_aef8cb:"中文繁体",
  comm_lang_0048:"日",
  wm_lang_f35fae:"傳真最多添加",
  comm_lang_0049:"時",
  comm_lang_0053:"設置密碼",
  wm_lang_78b124:"編輯其他郵箱帳戶",
  wm_lang_d17143:"轉發信頭",
  wm_lang_html_2a214e:"帶附件回復全部",
  comm_lang_0054:"確認密碼",
  comm_lang_0055:"查看密碼",
  comm_lang_0056:"隱藏密碼",
  comm_lang_0050:"分",
  comm_lang_0051:"設定的時間已過期",
  wm_lang_41e17a:"調整通報",
  comm_lang_0052:"郵件加密後，收件人需要解密才能查看郵件內容",
  wm_lang_html_2f8d6f:"昨天",
  wm_lang_html_a552fc:"郵箱用戶登錄",
  wm_lang_html_2ef722:"拒收",
  wm_lang_html_3c8045:"等客戶端發信後保存到服務器，請選擇此項。（",
  wm_lang_html_4bea88:"已回復",
  wm_lang_html_31c7ca:"自動加入通訊錄",
  wm_lang_0c0335:"待办時間",
  wm_lang_de0f82:"保存副本在郵箱中",
  wm_lang_01d7aa:"的",
  wm_lang_html_230505:"撤回",
  wm_lang_58ccec:"移動中",
  wm_lang_html_49f15f:"嵌套列表：",
  wm_lang_html_e4a827:"星標郵件",
  wm_lang_38cf16:"確定",
  wm_lang_html_ca7b67:"再次編輯",
  comm_lang_0057:"取消密碼",
  comm_lang_0058:"您好：",
  wm_lang_60ae02:"包含附件",
  comm_lang_0059:"這是一封加密郵件，需要解密後才能查看郵件內容，您可以通過其它管道向發件人詢問密碼。",
  wm_lang_6fc9ce:"自動轉發郵箱填寫有誤",
  comm_lang_0064:"您可以手動添加常用登入地址至",
  comm_lang_0065:"信任登入地點",
  comm_lang_0066:"，郵箱帳號异地登入時系統自動發送异地登入提醒，查看",
  comm_lang_0067:"信任登入地點",
  comm_lang_0060:"請輸入密碼",
  comm_lang_0061:"郵件解密失敗，請重新輸入密碼",
  comm_lang_0062:"郵件已解密，以下是解密後的郵件內容：",
  comm_lang_0063:"异地登入提醒",
  wm_lang_html_866bc3:"步驟一：選擇要上傳的",
  wm_lang_71b068:"宋體",
  wm_lang_html_c360e9:"排序",
  wm_lang_5719f5:"回執取消",
  wm_lang_a652de:"輸入的字串過長",
  wm_lang_39c764:"埠號",
  wm_lang_f013ea:"加載中",
  wm_lang_html_4404d5:"帳號安全",
  wm_lang_ee3f55:"國家",
  comm_lang_0068:"因IP定位精度有限，國內地點僅精確到\”市\"",
  wm_lang_f8de3d:"删除中",
  comm_lang_0069:"請選擇國家",
  wm_lang_a9e825:"郵件圖片顯示設定",
  wm_lang_d3298c:"個人通訊錄",
  comm_lang_0075:"操作",
  comm_lang_0076:"智能添加",
  comm_lang_0077:"手動添加",
  wm_lang_html_961cac:"代發",
  comm_lang_0078:"地點已存在",
  comm_lang_0071:"請選擇市",
  wm_lang_html_52228f:"擴容",
  wm_lang_html_1efeae:"緩慢",
  comm_lang_0072:"本次登入地點：",
  wm_lang_7e951d:"操作時間",
  comm_lang_0073:"當前信任地點",
  comm_lang_0074:"類型",
  wm_lang_44a0b8:"選字型大小",
  wm_lang_a7d3be:"底栏容器",
  wm_lang_aa8b9d:"家庭地址",
  wm_lang_2f4aad:"删除",
  comm_lang_0070:"請選擇省",
  wm_lang_3bb47b:"編輯成功",
  wm_lang_b1baab:"不顯示所有郵件中的圖片，手動點擊後顯示",
  wm_lang_html_7eacb4:"真實姓名",
  wm_lang_0f43f5:"密碼不能小於",
  wm_lang_d43e13:"組織通訊錄",
  wm_lang_html_a42d13:"張三郵件名稱",
  wm_lang_html_694fc5:"重繪",
  wm_lang_0875ef:"￥",
  wm_lang_f7c30e:"添加超大附件",
  comm_lang_0079:"异地登入日誌",
  wm_lang_32c65d:"標題",
  wm_lang_719156:"原發信時間：",
  wm_lang_html_0a25da:"支持導入",
  comm_lang_0086:"操作者",
  wm_lang_47631c:"請輸入文字名稱",
  comm_lang_0087:"操作時間",
  comm_lang_0088:"操作IP",
  wm_lang_91e9e8:"定時审核",
  comm_lang_0089:"操作內容",
  wm_lang_28cf54:"默認抄送地址",
  comm_lang_0082:"登入IP",
  comm_lang_0083:"參攷地點",
  wm_lang_439d6f:"您的郵箱密碼已過期，為了您的帳號安全，請修改密碼",
  comm_lang_0084:"登入方式",
  comm_lang_0085:"設定日誌",
  wm_lang_ce917f:"自定義名稱不能為空",
  comm_lang_0080:"最近30天內的异地登入日誌",
  comm_lang_0081:"登入時間",
  wm_lang_981cbe:"至",
  wm_lang_html_400521:"保留已自動轉發的郵件",
  wm_lang_a5bfd7:"新增成功",
  wm_lang_html_deb009:"下載安裝",
  wm_lang_1d468b:"結束日期",
  wm_lang_7a427c:"品質管制部",
  wm_lang_html_22b433:"草稿",
  wm_lang_9989a0:"標記為",
  wm_lang_1c8ac2:"客戶端授權碼”功能麼？開啟成功後，原郵箱密碼將不能登入客戶端，只能使用新增的授權碼登入。",
  wm_lang_html_8b6aed:"線上預覽",
  wm_lang_html_457406:"取消上傳",
  wm_lang_bffb1c:"個性簽名",
  wm_lang_02aaf1:"楷體",
  comm_lang_0097:"保存副本在郵箱中",
  wm_lang_2e42cc:"剩餘保留期限",
  comm_lang_0098:"您可以關閉撤回頁面，我們會將結果發送至您的郵箱",
  wm_lang_html_b50566:"、",
  comm_lang_0099:"安全設置",
  comm_lang_0093:"執行動作",
  comm_lang_0094:"自動轉發設定日誌",
  comm_lang_0095:"轉發地址",
  wm_lang_238ae0:"剩餘時間：",
  comm_lang_0096:"操作者郵箱",
  comm_lang_0090:"規則名稱",
  comm_lang_0091:"規則狀態",
  wm_lang_8b9c9b:"讀取文件失敗",
  comm_lang_0092:"觸發條件",
  wm_lang_30f7dd:"連接",
  wm_lang_html_922a77:"自動回復",
  wm_lang_e3d664:"請輸入正確的分機號碼",
  wm_lang_46323b:"是否回執郵件？",
  wm_lang_dac715:"超大附件上傳成功",
  wm_lang_html_f12e4a:"如果",
  wm_lang_html_bbdb15:"添加至郵件",
  wm_lang_0807a3:"青青幽境",
  wm_lang_html_bdc07d:"協定建議關閉此項）",
  wm_lang_fbd05a:"請選擇時間",
  wm_lang_html_e0a113:"回",
  wm_lang_be5fbb:"保存",
  wm_lang_8e16eb:"郵件分類規則",
  wm_lang_0f9b40:"分片",
  wm_lang_html_126fc3:"如果希望使用",
  wm_lang_cdd051:"請正確填寫最大值",
  wm_lang_193a8c:"電話號碼",
  wm_lang_html_9e5ffa:"基本信息",
  wm_lang_5cc232:"已删除",
  wm_lang_0611d8:"）",
  wm_lang_html_06ee96:"修改設定",
  wm_lang_6a5aa0:"已成功將連絡人進行分組",
  wm_lang_62a7e4:"新密碼不符合規則",
  wm_lang_html_f54c5e:"在本次網路安全攻防演練中，",
  wm_lang_html_b58c75:"添加",
  wm_lang_2ef722:"拒收",
  wm_lang_html_e4ef4a:"管理文件夾",
  wm_lang_827d98:"存放至",
  wm_lang_ea57da:"右側頁簽",
  wm_lang_html_6297bc:"不選",
  wm_lang_6231a2:"未回復",
  wm_lang_98c30b:"第二步，獲取",
  wm_lang_6d37b4:"搜索結果（個人通訊錄）",
  wm_lang_f26ef9:"下載",
  wm_lang_702513:"發送中",
  wm_lang_html_374237:"（",
  wm_lang_html_d3b98f:"，",
  wm_lang_html_3593a5:"部門：",
  wm_lang_549308:"夜深了，早休息！",
  wm_lang_html_713272:"普通附件",
  wm_lang_da0291:"不包含",
  wm_lang_708c9d:"請選擇",
  wm_lang_html_a6c60b:"格式有誤，示例",
  wm_lang_8441b3:"不限",
  wm_lang_73347e:"第一步，計算完成，並對",
  wm_lang_d41a62:"延期成功",
  wm_lang_html_00237d:"密送人：",
  wm_lang_7c6a2c:"姓名、郵箱、手機號搜索連絡人",
  wm_lang_html_4cbc13:"資料夾：",
  wm_lang_html_98f89e:"該操作將把連絡人在所有組中删除。",
  wm_lang_b1c5ea:"是否要將此郵件保存至草稿",
  wm_lang_html_b59b00:"已使用",
  wm_lang_html_528e20:"：選擇規則的觸發條件",
  wm_lang_html_7bbc73:"主題",
  wm_lang_e5b49e:"真實",
  wm_lang_html_e39b19:"時間從新到舊",
  wm_lang_html_14e6d8:"時間：",
  wm_lang_7b6234:"請填寫正確的郵箱地址",
  wm_lang_41716f:"公司",
  wm_lang_html_ae4fd4:"立即删除所有垃圾郵件",
  wm_lang_2c35d9:"黑名單地址",
  wm_lang_6eb535:"公司動態",
  wm_lang_html_e9e805:"郵件",
  wm_lang_694fc5:"重繪",
  wm_lang_html_7fe4a6:"其他郵箱帳號",
  wm_lang_9088d8:"按附件轉發最多支持勾選",
  wm_lang_html_35242c:"普通",
  wm_lang_html_92e3a8:"幫助",
  wm_lang_html_da4495:"郵箱：",
  wm_lang_html_c82a9d:"收取",
  wm_lang_html_21efd8:"暫無數據",
  wm_lang_html_cb8dc2:"主題昇冪",
  wm_lang_5c7c95:"删除帳號失敗",
  wm_lang_html_69e308:"含附件",
  wm_lang_69e94f:"點擊此處可快捷回復給所有人",
  wm_lang_html_857cee:"則",
  wm_lang_a7699b:"上傳成功",
  wm_lang_b44c0f:"開始日期",
  wm_lang_html_183abe:"通訊錄",
  wm_lang_html_3a580c:"回復全部",
  wm_lang_e4a827:"星標郵件",
  wm_lang_ca7b67:"再次編輯",
  wm_lang_d0f6ef:"計算的當前分塊：",
  wm_lang_html_2c808b:"點擊上傳",
  wm_lang_042be4:"僅從本組移除",
  wm_lang_html_980b27:"封",
  wm_lang_html_a00f23:"封郵件已選中",
  wm_lang_a98473:"文件夾名稱",
  wm_lang_html_8f4f08:"通訊錄中備註姓名",
  wm_lang_html_2064fc:"不顯示",
  wm_lang_html_b79a4e:"返",
  wm_lang_4bea88:"已回復",
  wm_lang_html_63e0ca:"需要回執",
  wm_lang_14fe7d:"我的名稱",
  wm_lang_50a9be:"公司郵編",
  wm_lang_html_f1d4ff:"自定義",
  wm_lang_html_cf10dc:"位",
  wm_lang_66f0da:"附件上傳尚未完成，請稍候",
  wm_lang_3fdaea:"添加成功",
  wm_lang_098730:"且不能包含",
  wm_lang_a46aa1:"添加其他郵箱帳號",
  wm_lang_html_6ffab1:"其它選項",
  wm_lang_html_40ad89:"公司郵編：",
  wm_lang_f23656:"最多創建",
  wm_lang_0007d1:"删除成功",
  wm_lang_bce314:"放入垃圾郵件文件夾（推薦）",
  wm_lang_198d41:"不能添加自己的郵箱",
  wm_lang_html_0f87e0:"更新提示信息",
  wm_lang_4f21b0:"傳真",
  wm_lang_html_3149de:"取消勾選",
  wm_lang_html_53cab4:"帳號信息",
  wm_lang_d0a548:"滿足以上條件時：則",
  wm_lang_eb0ef8:"電話最大數量為",
  wm_lang_0182f1:"時尚酷黑",
  wm_lang_b2352a:"保存到已發送",
  wm_lang_2cff3b:"仿宋",
  wm_lang_5a93d3:"電話",
  wm_lang_d7c0a1:"企業郵箱",
  wm_lang_168dfa:"隸書",
  wm_lang_7f9402:"收信人：",
  wm_lang_html_bee912:"査詢",
  wm_lang_6a23f1:"搜索結果（組織結構）",
  wm_lang_html_ae2e1f:"管理員已禁用自動轉發",
  wm_lang_html_f03d42:"包含成員：",
  wm_lang_html_d16180:"昵稱：",
  wm_lang_dec892:"：",
  wm_lang_html_2bf9a9:"群發單顯",
  wm_lang_db1c89:"首頁",
  wm_lang_d6aac9:"無法移動",
  wm_lang_e06494:"公司地址",
  wm_lang_18c634:"默認",
  wm_lang_19ac67:"低",
  wm_lang_html_7a2e8b:"這不是垃圾郵件",
  wm_lang_01468d:"埠號不能為空",
  wm_lang_html_1edff0:"回復",
  wm_lang_html_dfe170:"無限期",
  wm_lang_html_f25118:"您的郵件已發送！",
  wm_lang_21e106:"轉發",
  wm_lang_html_ecda36:"對不起，文件過大，建議您下載之後進行查看",
  wm_lang_b5771a:"登入後默認顯示",
  wm_lang_561caa:"郵箱格式錯誤",
  wm_lang_5ce1e1:"郵件另存下載",
  wm_lang_461d8d:"最新公告",
  wm_lang_3bc5e6:"郵箱",
  wm_lang_54e5de:"上傳失敗",
  wm_lang_ce219a:"最先做出裁决的审核人的結果，即作為最終裁决結果",
  wm_lang_9365f3:"郵件主題標題郵件主題標題郵件主題標題郵件主題標題",
  wm_lang_html_27dfde:"員工編號：",
//自定义多语言字段://自定義多語言字段
  wm_lang_3755ef:"正在驗證帳號",
  wm_lang_html_1501d5:"郵件主題",
  wm_lang_8572ea:"請填寫最小值",
  wm_lang_html_f6d477:"公司：",
  wm_lang_html_092ba7:"高級搜索",
  wm_lang_html_2dc4ac:"北京二六三企業通信有限公司",
  wm_lang_738e4a:"您查看的公告已經不存在",
  wm_lang_314f60:"保存成功，需要",
  wm_lang_7093b9:"已取消清空",
  wm_lang_cd0ed2:"已移動到收件箱",
  wm_lang_f7a9dd:"此郵件內容已被修改",
  wm_lang_html_7a311d:"回復：【陞級公告】暢聽支持",
  wm_lang_67bc37:"網盤",
  wm_lang_641b90:"自動轉發勾選後轉發內容不能為空",
  wm_lang_7650a1:"不支持空格",
  wm_lang_c34281:"已取消删除",
  wm_lang_20601f:"電話重複",
  wm_lang_002a67:"最近使用日期",
  wm_lang_a12b8a:"我的文件",
  wm_lang_html_26f9bf:"子菜单",
  wm_lang_cfbf6f:"微信",
  wm_lang_html_d7405e:"清單名稱：",
  wm_lang_b43f83:"節點點擊回檔",
  wm_lang_61f562:"此操作將永久删除該文件",
  wm_lang_html_7b4a28:"郵箱服務",
  wm_lang_html_aa4d94:"消",
  wm_lang_3c18db:"帳號檢測圖標",
  wm_lang_e2cd2e:"客戶端授權碼”功能麼？關閉成功後，所有客戶端授權碼將會被全部删除，只能使用原郵箱密碼登入客戶端。",
  wm_lang_html_383698:"最近登入日誌：",
  wm_lang_html_35c8ad:"自動轉發",
  wm_lang_371528:"市",
  wm_lang_8d90d2:"選擇超大附件",
  wm_lang_html_5cc232:"已删除",
  wm_lang_html_3b3495:"修復寫信頁面對收件人地址合法性的校驗問題；",
  wm_lang_47b0da:"需所有审核人审核通過，郵件才會被正常投遞；若其中一人做出拒絕判定，此郵件則被删除",
  wm_lang_html_66c3e5:"綠意風情",
  wm_lang_html_c6b4d7:"電話：",
  wm_lang_0c1fec:"秒",
  wm_lang_18d771:"請輸入正確的手機號碼",
  wm_lang_243e1d:"授權碼用途不能為空",
  wm_lang_9034c8:"預覽簽名",
  wm_lang_ba6025:"多個郵箱地址之間請以英文逗號分隔",
  wm_lang_a1d1e5:"大於等於",
  wm_lang_html_c228dd:"封郵件，",
  wm_lang_html_cdd451:"已全部撤回",
  wm_lang_23eb0e:"昵稱",
  wm_lang_196ef3:"家庭郵編",
  wm_lang_html_0eab0c:"代發郵件：請注意！",
  wm_lang_612c43:"添加其他郵箱帳戶",
  wm_lang_html_b3b1f7:"剔除",
  wm_lang_html_508db5:"登入時收取",
  wm_lang_html_465afe:"人",
  wm_lang_html_61a68d:"無附件",
  wm_lang_dade72:"設定頁表單組件",
  wm_lang_html_6a3db1:"封郵件",
  wm_lang_html_74e5c0:"定時發送",
  wm_lang_9ef16d:"工具列按鈕顯示",
  wm_lang_671c0d:"日語",
  wm_lang_5c6881:"未填寫",
  wm_lang_html_7854b5:"啟用",
  wm_lang_html_918b52:"未選中任何連絡人，按一下壹條連絡人信息在此處顯示",
  wm_lang_html_69a924:"安全性原則零失誤",
  wm_lang_html_f6ccd0:"郵件大小",
  wm_lang_bc2f65:"韓文",
  wm_lang_870802:"規則名稱",
  wm_lang_html_0be5a1:"換膚",
  wm_lang_1e86ec:"删除帳號成功",
  wm_lang_e3127c:"格式",
  wm_lang_5893fa:"郵箱帳戶",
  wm_lang_c2460e:"傳真最大數量為",
  wm_lang_5ee1ff:"郵箱名不能為空",
  wm_lang_html_a8b0c2:"全部",
  wm_lang_12da81:"寫信完成頁",
  wm_lang_html_cbfcf6:"設定個性簽名",
  wm_lang_20be4e:"加載中，請稍後",
  wm_lang_8483ed:"生日",
  wm_lang_e6f070:"审核時間",
  wm_lang_html_645dbc:"預覽",
  wm_lang_html_625fb2:"取消",
  wm_lang_html_918362:"顯示設定",
  wm_lang_65f627:"上傳新文件",
  wm_lang_html_f48072:"安全提示：",
  wm_lang_bf3c5b:"韓語",
  wm_lang_html_ff1c7d:"查看信頭",
  wm_lang_html_c4746d:"未選中任何郵件，按一下壹封在此處顯示",
  wm_lang_153fa6:"選擇",
  wm_lang_952f2d:"文件上傳已達到最大上限數",
  wm_lang_f3a485:"新建文件夾",
  wm_lang_8f40db:"賦值",
  wm_lang_fcbb1f:"個文件，請删除當前文件後重新上傳",
  wm_lang_html_2cc0ca:"修復讀信頁面樣式、亂碼等郵件解析問題；",
  wm_lang_3d14d1:"省",
  wm_lang_670d63:"確認新密碼",
  wm_lang_html_2cb96f:"客戶端設定",
  wm_lang_64a156:"您沒有選擇任何文件！",
  wm_lang_6b0bc6:"操作者",
  wm_lang_5f10ee:"經典木紋",
  wm_lang_554626:"第三步，賦值",
  wm_lang_html_c8a933:"立即修改",
  wm_lang_543586:"請輸入正確的電話號碼",
  wm_lang_df4b35:"當前已有規則",
  wm_lang_html_919466:"包含部門：",
  wm_lang_html_d88651:"剩餘空間",
  wm_lang_21cf5e:"郵箱最大數量為",
  wm_lang_html_f75896:"所在組：",
  wm_lang_html_a72631:"必須包含大寫字母、小寫字母、數位、符號任意",
  wm_lang_0eeee5:"設定過濾規則，對郵件進行分類處理。",
  wm_lang_211cfb:"服務器不能為空",
  wm_lang_html_8ad629:"已讀",
  wm_lang_05e8d4:"發送閱讀回執",
  wm_lang_b90ee1:"普通上傳組件",
  wm_lang_html_854db2:"全部置為已讀",
  wm_lang_6105e1:"反垃圾處理",
  wm_lang_html_740499:"郵件從大到小",
  wm_lang_html_86ed3d:"移動到",
  wm_lang_c45357:"系統提示",
  wm_lang_html_44a2c7:"個連絡人",
  wm_lang_html_288f0c:"清空",
  wm_lang_f070aa:"您好",
  wm_lang_716c3d:"街道",
  wm_lang_7deb96:"發信後收件人",
  wm_lang_24e8a8:"系統將自動清理\"垃圾箱\"中超過",
  wm_lang_4a0838:"新建簽名",
  wm_lang_ac9f45:"回復成功",
  wm_lang_e0b014:"分類過濾規則最多可添加",
  wm_lang_0c9eaa:"的值為：",
  wm_lang_html_67596c:"沒有任何郵件",
  wm_lang_html_ec0bce:"相關",
  wm_lang_html_cda4d5:"從連絡人中選擇",
  wm_lang_html_e13556:"包含",
  wm_lang_f5854e:"已取消星標",
  wm_lang_0c498b:"請聯系管理員",
  wm_lang_cecc29:"寫信",
  wm_lang_html_93d159:"已發送",
  wm_lang_05dfc3:"回執成功",
  wm_lang_aa2fb1:"請選擇日期",
  wm_lang_0b2f8e:"中文简体",
  wm_lang_f9fb6a:"English",
  wm_lang_ff29b9:"郵件發送成功",
  wm_lang_html_053355:"後緊急成立統籌小組進行",
  wm_lang_b1415d:"請先選擇要删除的地址！",
  wm_lang_html_78ad95:"附加意見：",
  wm_lang_d3950d:"粉色回憶",
  wm_lang_8beefb:"审核結果",
  wm_lang_0ad062:"第四步，丟包，等待",
  wm_lang_html_196bf0:"您尚未添加連絡人",
  wm_lang_e0b004:"黑體",
  wm_lang_f10ed4:"新建規則",
  wm_lang_7c2f8e:"傳真號碼",
  wm_lang_348913:"皮膚",
  wm_lang_html_3950e5:"時間從舊到新",
  wm_lang_html_95bde0:"新增定時自動回復功能，支持按照時間週期設定自動回復；",
  wm_lang_8e22f1:"左側導航",
  wm_lang_fd4cfa:"审核類型：",
  wm_lang_ca5f4c:"低級（除黑名單外的郵件，都不會判為垃圾郵件）",
  wm_lang_html_f5de9e:"附件名",
  wm_lang_html_aab57a:"反選",
  wm_lang_82da89:"审核人",
  wm_lang_html_d87502:"個字符以上主持人郵箱填寫",
  wm_lang_572fc4:"系統文件夾不可删除",
  wm_lang_html_89da89:"：執行動作",
  wm_lang_a4c993:"您確定要删除組",
  wm_lang_b87f22:"审核失敗（",
  wm_lang_230505:"撤回",
  wm_lang_333e4b:"目的文件夾和源文件夾相同",
  wm_lang_22c795:"授權碼最多可添加",
  wm_lang_46042d:"超大附件",
  wm_lang_5c0086:"自定義名稱不能超過",
  wm_lang_5f6025:"頁面後生效。",
  wm_lang_5f4fd0:"頂栏容器",
  wm_lang_7354e6:"最近使用",
  wm_lang_html_5a3009:"提醒週期",
  wm_lang_html_f83e6b:"設定默認發信人姓名",
  wm_lang_a85cce:"規則狀態",
  wm_lang_html_ca5b2d:"自動轉發與回復",
  wm_lang_html_8347a9:"修改",
  wm_lang_2cf58f:"選項四",
  wm_lang_6732fd:"所有郵件",
  wm_lang_22b234:"在此文件夾下",
  wm_lang_html_ab20cc:"和",
  wm_lang_2685dc:"清空成功",
  wm_lang_2a8140:"删除所選的黑名單地址？",
  wm_lang_0efb20:"請至少選擇一個",
  wm_lang_e61f2c:"同意",
  wm_lang_312df5:"您確定要删除此客戶端授權碼麼？删除成功後，此授權碼將無法在客戶端上登入。",
  wm_lang_6aea59:"導入到組",
  wm_lang_html_83aa19:"自動轉發地址上限",
  wm_lang_40ff1a:"位，不大於",
  wm_lang_8dd066:"綁定手機",
  wm_lang_html_ab9ed8:"沒有搜索到匹配結果",
  wm_lang_html_021161:"性別：",
  wm_lang_65939c:"觸發條件",
  wm_lang_fbd2b1:"共",
  wm_lang_cc1bac:"條",
  wm_lang_html_992cd2:"勇者前行",
  wm_lang_f3b7af:"密碼用途",
  wm_lang_70a47f:"删除後，此附件的收件人將無法下載此附件。確定删除麽？",
  wm_lang_442c6a:"組",
  wm_lang_html_894a10:"未讀",
  wm_lang_defd7b:"發信人：",
  wm_lang_html_52b365:"步驟",
  wm_lang_html_d4095c:"常規設定",
  wm_lang_86988e:"郵箱重複",
  wm_lang_6367e7:"順序",
  wm_lang_9ad8d3:"授權密碼",
  wm_lang_html_392898:"，其中",
  wm_lang_html_44c32e:"組名稱",
  wm_lang_html_026601:"或認證的用戶名",
  wm_lang_html_d8b930:"郵件由",
  wm_lang_24969a:"抄送人",
  wm_lang_a41baf:"請填寫簽名名稱",
  wm_lang_b2fbc1:"至少填寫一項信息",
  wm_lang_html_c33c30:"商務辦公",
  wm_lang_html_751ce6:"備註：",
  wm_lang_19a1ee:"草稿保存失敗",
  wm_lang_6f67c4:"文件夾名不能包含後面任意字符：",
  wm_lang_html_92636e:"跳過",
  wm_lang_6b0fd2:"郵件列表",
  wm_lang_html_bf74e9:"發件人自定義姓名",
  wm_lang_html_930882:"個",
  wm_lang_787b56:"性別",
  wm_lang_7854b5:"啟用",
  wm_lang_46ad5e:"超大附件空間不足",
  wm_lang_html_a675fc:"此密碼由系統隨機生成，請複製後妥善保管，如有遺忘，請删除重建。",
  wm_lang_html_f7b320:"號",
  wm_lang_html_88c952:"發件人",
  wm_lang_96900d:"選",
  wm_lang_5cd3b6:"高級（只有白名單、同域用戶、通訊錄連絡人發來的郵件不視為垃圾郵件）",
  wm_lang_b7abee:"選項二",
  wm_lang_b6d16a:"導入成功",
  wm_lang_25c9ea:"审核人：",
  wm_lang_e75969:"收件箱",
  wm_lang_html_ca746b:"文字",
  wm_lang_c2b9f4:"根目錄",
  wm_lang_8abc56:"操作栏",
  wm_lang_html_bb93ed:"備",
  wm_lang_696f5a:"創建日期",
  wm_lang_0c9e6a:"長度在",
  wm_lang_html_ed8f43:"同時將本組中所有連絡人從個人通訊錄中徹底删除。",
  wm_lang_html_93d79c:"的連絡人",
  wm_lang_html_54480f:"企業郵箱作為防守組織之一，在接到三峽集團的行動邀請",
  wm_lang_html_8f5c40:"家庭郵編：",
  wm_lang_f30bfb:"多個轉發地址之間請以英文逗號分隔",
  wm_lang_html_dec892:"：",
  wm_lang_1edff0:"回復",
  wm_lang_5f4112:"返回",
  wm_lang_html_614fc6:"示例：",
  wm_lang_html_390209:"不能包含用戶名或功能變數名稱",
  wm_lang_html_6b8677:"手動加入通訊錄",
  wm_lang_330363:"成功",
  wm_lang_0d64f2:"中級（推薦，根據系統的反垃圾規則及黑白名單設定識別垃圾郵件）",
  wm_lang_html_4b9c32:"重置",
  wm_lang_5ac57c:"文本框",
  wm_lang_html_2d23c6:"审核記錄：",
  wm_lang_html_12d795:"更早的更新記錄",
  wm_lang_3683f3:"顯示郵件圖片",
  wm_lang_973732:"已轉發",
  wm_lang_c2fe62:"篩選",
  wm_lang_c6cceb:"日程",
  wm_lang_78623e:"每天",
  wm_lang_dcc242:"支持最多創建",
  wm_lang_a5ff1b:"未轉發",
  wm_lang_html_d4c366:"檢測中",
  wm_lang_74225e:"下拉二",
  wm_lang_306a2a:"服務器長度不得超過",
  wm_lang_971f54:"微軟雅黑",
  wm_lang_a6beb9:"開關",
  wm_lang_6a5f04:"請輸入正確的郵箱地址",
  wm_lang_3caa33:"啟用該帳號",
  wm_lang_html_55c3f6:"取",
  wm_lang_f9d94b:"永久删除後郵件將無法恢復，您確認删除嗎？",
  wm_lang_21cad5:"安全登入驗證",
  wm_lang_html_22f94c:"域公告郵件共",
  wm_lang_af3c66:"郵箱最多添加",
  wm_lang_html_1a63ac:"示例",
  wm_lang_html_6e0780:"請用真實的帳號登入",
  wm_lang_c00500:"抄送人：",
  wm_lang_18b2e0:"您被設定了“禁止自動轉發到外域”,請與管理員聯系！",
  wm_lang_1e9b8e:"請正確填寫最小值",
  wm_lang_html_0c71d6:"設定預設字體",
  wm_lang_html_4a0838:"新建簽名",
  wm_lang_237651:"郵件正在發送中",
  wm_lang_ac1e1c:"收件人：",
  wm_lang_d69797:"存在重複的轉發地址",
  wm_lang_html_9ab2e7:"為非常用連絡人，請注意核實對方身份",
  wm_lang_html_2f293a:"已星標",
  wm_lang_68018f:"幼圓",
  wm_lang_html_fcbc6a:"空格",
  wm_lang_html_cce9c9:"上次修改密碼：",
  wm_lang_6e7b20:"只回復寄件者",
  wm_lang_70281d:"請輸入正確的電話",
  wm_lang_5df03b:"請輸入文件夾名稱",
  wm_lang_e10150:"文件夾名不能包含空格和特殊字符",
  wm_lang_8a45a9:"您確定要將此超大附件續期？",
  wm_lang_8ad629:"已讀",
  wm_lang_0bb8f9:"垃圾郵件",
  wm_lang_cd043c:"請輸入當前密碼",
  wm_lang_a8b0c2:"全部",
  wm_lang_html_d3950d:"粉色回憶",
  wm_lang_74e5c0:"定時發送",
  wm_lang_95b351:"編輯",
  wm_lang_919ca6:"下拉一",
  wm_lang_55481b:"不提醒",
  wm_lang_3d99b6:"多個地址之間以英文逗號分隔",
  wm_lang_html_a7a342:"定",
  wm_lang_html_1c02de:"往來郵件",
  wm_lang_html_8d0cfb:"添加文件",
  wm_lang_f857f6:"密碼用途不能包含空格和",
  wm_lang_html_66eeac:"全選",
  wm_lang_html_897d4f:"解决垃圾郵件的識別和誤判問題；",
  wm_lang_html_6b05b5:"發信設定",
  wm_lang_e4a3b5:"請輸入黑名單地址",
  wm_lang_f0d640:"兩次輸入密碼不一致",
  wm_lang_96ce79:"，無法添加該文件",
  wm_lang_html_6219c6:"的郵件列表",
  wm_lang_d9e569:"添加帳號成功",
  wm_lang_fddcd7:"導入失敗",
  wm_lang_html_58378f:"正文",
  wm_lang_html_e93381:"企業郵箱助三峽",
  wm_lang_html_536d2c:"直接删除郵件",
  wm_lang_d27299:"僅對每個發件人發送一次自動回復",
  wm_lang_443f46:"多選",
  wm_lang_35a2b9:"您確定要開啟",
  wm_lang_html_552823:"保存為默認簽名",
  wm_lang_3fea7c:"狀態",
  wm_lang_html_e5ff1a:"請選擇要添加的檔",
  wm_lang_c3ba16:"已歸檔",
  wm_lang_html_6b0fd2:"郵件列表",
  wm_lang_992cd2:"勇者前行",
  wm_lang_html_df99b1:"您的郵箱帳號存在一定的安全風險，請按照以下提示進行優化",
  wm_lang_html_a46aa1:"添加其他郵箱帳號",
  wm_lang_html_4c785f:"添加附件",
  wm_lang_html_4a5c68:"上傳至我的網盤",
  wm_lang_html_e0745b:"取消星標",
  wm_lang_0d8f65:"紅色簡約",
  wm_lang_19fcb9:"時間",
  wm_lang_html_442c6a:"組",
  wm_lang_html_5751bf:"座機：",
  wm_lang_2b9bad:"通訊組名稱不能為空",
  wm_lang_27bf68:"您的郵箱密碼過於簡單，為了您的帳號安全，請修改密碼",
  wm_lang_fb5bf1:"收件人",
  wm_lang_9dcd1b:"您確定要將所選的連絡人移出此組？",
  wm_lang_html_2a2080:"文件。",
  wm_lang_511fd1:"您當前正在使用”群發單顯”功能，此功能對群發的郵件，採用分別發送，每個收件人只能看到自己的郵箱地址，是否繼續？",
  wm_lang_html_600565:"不能包含三個連續或相同的字符",
  wm_lang_html_249aba:"天",
  wm_lang_html_40ff1a:"位，不大於",
  wm_lang_7edd32:"晚上好！",
  wm_lang_html_c3eb73:"文件夾管理",
  wm_lang_html_abb501:"金色時光",
  wm_lang_html_e75969:"收件箱",
  wm_lang_e6df5b:"添加說明",
  wm_lang_html_cb0e98:"勾選全部",
  wm_lang_12f1d7:"結束",
  wm_lang_4ff1e7:"日期",
  wm_lang_19fee2:"每五天",
  wm_lang_a30c4e:"新建組",
  wm_lang_3cec17:"密碼長度不得超過",
  wm_lang_html_727725:"公司地址：",
  wm_lang_html_267e95:"新建連絡人",
  wm_lang_9c49ab:"確定不填寫主題嗎",
  wm_lang_html_cc4637:"不能用過於簡單的密碼，如",
  wm_lang_2f2786:"操作內容",
  wm_lang_5abe91:"未星標",
  wm_lang_d26ecc:"郵箱名",
  wm_lang_html_bcbfe2:"黑名單",
  wm_lang_html_90585c:"設定代办",
  wm_lang_html_c2fe62:"篩選",
  wm_lang_650b9f:"至少選擇一個對應字段",
  wm_lang_da760a:"其他郵箱帳戶（",
  wm_lang_3806fe:"轉發地址",
  wm_lang_html_918be6:"種的組合",
  wm_lang_f361ce:"已設為未讀",
  wm_lang_1e328f:"請選擇上傳文件",
  wm_lang_html_570e7f:"給我發送提醒郵件",
  wm_lang_ae4b6b:"個簽名",
  wm_lang_59592b:"簽名名稱",
  wm_lang_html_0182f1:"時尚酷黑",
  wm_lang_10a48a:"請添加收件人後再發送",
  wm_lang_358fd1:"移動成功",
  wm_lang_397654:"上傳頭像圖片只能是",
  wm_lang_4351f4:"早上好！",
  wm_lang_html_458e42:"已勾選本頁",
  wm_lang_2f293a:"已星標",
  wm_lang_249aba:"天",
  wm_lang_html_e37075:"高級設定",
  wm_lang_html_be2525:"簽名",
  wm_lang_41ec00:"框",
  wm_lang_html_88866c:"已部分撤回",
  wm_lang_html_2d76b9:"職位：",
  wm_lang_b4f3cb:"正在收取",
  wm_lang_f2e77e:"每四天",
  wm_lang_f0b9f4:"第五步，分片上傳",
  wm_lang_html_f515f8:"重新檢測",
  wm_lang_html_808773:"發件人降序",
  wm_lang_a24ab0:"請再次輸入密碼",
  wm_lang_html_3d2a2f:"上傳挿件，支持極速秒傳、中斷點續傳",
  wm_lang_html_c00500:"抄送人：",
  wm_lang_ace6d1:"勾選了自動回復，則自動回復內容不能為空",
  wm_lang_674b1e:"收信帳號，可以收取其他郵箱的郵件。",
  wm_lang_2bebdd:"選擇日期",
  wm_lang_html_ecf9b6:"自動轉發設定日誌",
  wm_lang_cc2644:"請標記此授權碼的用途，以免遺忘",
  wm_lang_35c8ad:"自動轉發",
  wm_lang_html_b4cc1c:"特殊字符",
  wm_lang_html_b411f8:"新增全文檢索搜尋功能，支持按照郵件正文或附件名搜索郵件；",
  wm_lang_88c952:"發件人",
  wm_lang_0ec9ea:"更多",
  wm_lang_e4b8bb:"總封數",
  wm_lang_html_dfe48d:"個，",
  wm_lang_29d8d8:"個人備註",
  wm_lang_316206:"設定待办",
  wm_lang_html_b960ee:"上傳至超大附件",
  wm_lang_894a10:"未讀",
  wm_lang_html_0bb8f9:"垃圾郵件",
  wm_lang_01efad:"新增客戶端授權碼",
  wm_lang_html_2161fa:"不能與原密碼相同",
  wm_lang_2d711b:"內容",
  wm_lang_html_5f4112:"返回",
  wm_lang_html_e366cc:"設定",
  wm_lang_7173f8:"拒絕",
  wm_lang_html_bf498c:"初始默認提示文字",
  wm_lang_295bb7:"語言",
  wm_lang_html_0345b9:"發件人昇冪",
  wm_lang_a8424d:"請重新輸入",
  wm_lang_html_e7d4e2:"生成授權碼",
  wm_lang_361e3d:"左側設定導航",
  wm_lang_958962:"編輯文件夾",
  wm_lang_28ee2b:"無許可權，請聯系管理員",
  wm_lang_html_79d3ab:"複製",
  wm_lang_03dcfd:"每三天",
  custom_lang_0001:"請輸入密碼",
  custom_lang_0002:"兩次密碼輸入不一致",
  custom_lang_0003:"您好：",
  custom_lang_0004:"這是一封加密郵件，需要解密後才能查看郵件內容，您可以通過其它管道向發件人詢問密碼",
  custom_lang_0005:"以下地址不存在或格式錯誤，請檢查：",
  custom_lang_0006:"您要删除以下資料夾嗎？",
  custom_lang_0007:"操作已成功，您的裁决判定是",
  custom_lang_0008:"顯示",
  custom_lang_0009:"請勿重複添加",
  custom_lang_0010:"郵箱",
  custom_lang_0011:"已存在！",
  custom_lang_0012:"只能上傳csv格式檔案，且不超過",
  custom_lang_0013:"將",
  custom_lang_0014:"中的連絡人以CSV格式匯出。",
  custom_lang_0015:"通訊組名稱長度不能超過",
  custom_lang_0016:"個字元",
  custom_lang_0017:"您尚未收到任何域公告郵件。",
  custom_lang_0018:"更多操作",
  custom_lang_0019:"另存為eml檔案",
  custom_lang_0020:"手動添加常用登入地址至",
  custom_lang_0021:"信任登入地點",
  custom_lang_0022:"，郵箱帳號异地登入時系統自動發送异地登入提醒，點此查看",
  custom_lang_0023:"异地登入日誌",
  custom_lang_0024:"操作失敗",
  custom_lang_0025:"請選擇信任地點",
  custom_lang_0026:"請選擇信任地點，至少選擇“省”",
  custom_lang_0027:"删除所選的信任地點？",
  custom_lang_0028:"最多添加20個信任地點",
  custom_lang_0029:"直接把檔案拖放至此區域內，即可作為附件添加",
  custom_lang_0030:"條匹配，請輸入更多資訊以縮小範圍",
  custom_lang_0031:"密碼長度不能大於20比特",
  custom_lang_0032:"更多結果請查看郵件撤回通知",
  custom_lang_0033:"登入",
  custom_lang_0034:"密碼錯誤",
  custom_lang_0035:"定時發送郵件",
  custom_lang_0036:"請選擇定時發信時間",
  custom_lang_0037:"設定的時間已過期",
  custom_lang_0038:"已選擇",
  custom_lang_0039:"未選中任何連絡人，按一下一條連絡人資訊在此顯示",
  custom_lang_0040:"今天",
  custom_lang_0041:"明天",
  custom_lang_0042:"昨天",
  custom_lang_0043:"附件大小超限，最大",
  custom_lang_0044:"收件人數超限，最多",
  custom_lang_0045:"您所選擇的檔案已經超過了普通附件",
  custom_lang_0046:"的大小上限，請上傳到超大附件。",
  custom_lang_0047:"有效期",
  custom_lang_0048:"密碼不能包含空格",
  custom_lang_0049:"請輸入密碼：",
  custom_lang_0050:"是否將",
  custom_lang_0051:"加入黑名單？",
  custom_lang_0052:"請選擇要删除的地點",
  custom_lang_0053:"不使用",
  custom_lang_0054:"默認排序",
  custom_lang_0055:"姓名昇冪",
  custom_lang_0056:"姓名降序",
  custom_lang_0057:"郵寄地址昇冪",
  custom_lang_0058:"郵寄地址降序",
  custom_lang_0059:"請上傳小於1M的圖片",
  custom_lang_0060:"删除組",
  custom_lang_0061:"外部連絡人",
  custom_lang_0062:"收件箱",
  custom_lang_0063:"寄件匣",
  custom_lang_0064:"已删除",
  custom_lang_0065:"草稿箱",
  custom_lang_0066:"垃圾箱",
  custom_lang_0067:"已歸檔",
  custom_lang_0068:"已備份",
  custom_lang_0069:"星標郵件",
  custom_lang_0070:"待辦郵件",
  custom_lang_0071:"內部網絡",
  custom_lang_0072:"您好!",
  custom_lang_0073:"您要清空以下資料夾嗎？",
  custom_lang_0074:"已移動到",
  custom_lang_0075:"成功撤回",
  custom_lang_0076:"投遞中或分類過濾删除，無法撤回",
  custom_lang_0077:"撤回失敗，郵件可能已被删除",
  custom_lang_0078:"對方非本郵件系統郵箱或郵箱地址不存在，無法撤回",
  custom_lang_0079:"步驟2：選擇所要導入的分組及檔案所對應的欄位名稱。",
  custom_lang_0080:"是否删除簽名",
  custom_lang_0081:"是否删除 ",
  custom_lang_0082:" 賬號",
  custom_lang_0083:"自動轉發地址數量超過最大限制",
  custom_lang_0084:"數量不能超過",
  custom_lang_0085:"等自動回復標識時，將不會再自動給對方回復。",
  custom_lang_0086:"時間段不能為空",
  custom_lang_0087:"開啟自動轉發",
  custom_lang_0088:"關閉自動轉發",
  custom_lang_0089:"修改自動轉發",
  custom_lang_0090:"未知",
  custom_lang_0091:"新建規則",
  custom_lang_0092:"修改規則",
  custom_lang_0093:"删除規則",
  custom_lang_0094:"上移規則",
  custom_lang_0095:"下移規則",
  custom_lang_0096:"4.只能撤回",
  custom_lang_0097:"小時",
  custom_lang_0098:"日",
  custom_lang_0099:"內發送的郵件",
  custom_lang_0100:"登入二次驗證",
  custom_lang_0101:"根據此帳號的安全設置，本次登入需要簡訊驗證。 （如遇到特殊情况無法驗證，您可聯系公司管理員解綁手機）",
  custom_lang_0102:"已綁定手機",
  custom_lang_0103:"獲取驗證碼",
  custom_lang_0104:"簡訊驗證碼",
  custom_lang_0105:"請輸入驗證碼",
  custom_lang_0106:"同一瀏覽器登入免二次驗證",
  custom_lang_0107:"60秒再次獲取",
  custom_lang_0108:"驗證碼簡訊已發送，請注意查收。",
  custom_lang_0109:"驗證碼輸入有誤",
  custom_lang_0110:"驗證碼無效或已過期",
  custom_lang_0111:"安全提醒",
  custom_lang_0112:"綁定手機",
  custom_lang_0113:"提醒管道",
  custom_lang_0114:"郵件提醒",
  custom_lang_0115:"簡訊提醒",
  custom_lang_0116:"安全登入",
  custom_lang_0117:"登入二次驗證",
  custom_lang_0118:"開啟二次登入驗證後，用戶登錄網頁郵箱時，除帳號密碼驗證外，還需要二次驗證",
  custom_lang_0119:"驗證管道",
  custom_lang_0120:"每次登入驗證",
  custom_lang_0121:"异地登入驗證",
  custom_lang_0122:"手機號碼",
  custom_lang_0123:"簡訊驗證碼",
  custom_lang_0124:"請輸入手機號碼",
  custom_lang_0125:"請輸入驗證碼",
  custom_lang_0126:"手機號碼格式有誤",
  custom_lang_0127:"驗證碼輸入有誤",
  custom_lang_0128:"獲取驗證碼",
  custom_lang_0129:"秒再次獲取",
  custom_lang_0130:"驗證碼簡訊已發送，請注意查收。",
  custom_lang_0131:"若無法通過原手機號碼驗證，請聯系公司管理員進行解綁。",
  custom_lang_0132:"您的郵箱帳號已綁定手機",
  custom_lang_0133:"解綁手機",
  custom_lang_0134:"綁定成功",
  custom_lang_0135:"解綁成功",
  custom_lang_0136:"解除綁定",
};



// WEBPACK FOOTER //
// ./src/vueI18n/hk.js